// Unpublished Work © 2021-2022 Deere & Company

import t from 'tcomb';
import {Customer} from '../customer';
import {PageStatus} from '../page-status';

export const SelectBusinessContact = t.struct({
    contacts: t.list(Customer),
    customer: t.maybe(Customer),
    pageStatus: PageStatus
}, {
    defaultProps: {
        contacts: [],
        customer: null,
        pageStatus: PageStatus.meta.map.COMPLETE
    },
    name: 'SelectBusinessContact',
    strict: true
});
